import moment from 'moment-timezone';
import {
  CUSTOM_OPTIONS_REQUEST,
  CUSTOM_OPTIONS_SUCCESS,
  CUSTOM_OPTIONS_FAILURE,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function customOptionsRequest() {
  return {
    type: CUSTOM_OPTIONS_REQUEST,
  };
}

function customOptionsSuccess(data, token = null) {
  return {
    type: CUSTOM_OPTIONS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function customOptionsError(message) {
  return {
    type: CUSTOM_OPTIONS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchCustomOptions(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(customOptionsRequest());
    if (!fresh) {
      let customOptionsData = {};
      try {
        customOptionsData = JSON.parse(getItem(`${config.get('appName')}.customOptions`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !customOptionsData.data ||
        config.get('version') !== customOptionsData.version ||
        moment().isAfter(moment(customOptionsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(customOptionsSuccess(customOptionsData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/custom_options/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.customOptions`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(customOptionsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, customOptionsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/customOptions.js